export default "__VITE_ASSET__Biuyd3yk__"